import { render, staticRenderFns } from "./MarkdownEditor.vue?vue&type=template&id=dc36f4a2&scoped=true&"
import script from "./MarkdownEditor.vue?vue&type=script&lang=ts&"
export * from "./MarkdownEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc36f4a2",
  null
  
)

export default component.exports